import * as React from "react";

const SvgArrowDown = props => <svg viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg" {...props}><g transform="matrix(2,0,0,2,0,0)"><path d="M.541,5.627,11.666,18.2a.5.5,0,0,0,.749,0L23.541,5.627" fill="none" stroke="#000000" strokeLinecap="round" strokeLinejoin="round" /></g></svg>;

export default SvgArrowDown;